import {
  DURUM_ETIKETI,
  type BakiyeSatiri,
  type IzinDurumu,
  type IzinTalebiOzeti,
} from '../api/izin';

/**
 * İZİN EKRANLARININ PAYLAŞILAN PARÇALARI.
 *
 * `Izin.tsx` ile `IzinOnay.tsx` bunları paylaşıyor. Birinin içine konsaydı
 * ikisi birbirini içe aktarır ve DÖNGÜSEL bağımlılık oluşurdu — 0.31.0'da
 * `Metin` bileşeninde tam olarak bu olmuştu (SÖZLEŞME §16).
 */

const DURUM_BICIMI: Record<IzinDurumu, string> = {
  taslak: 'bg-slate-100 text-slate-600 ring-slate-200',
  sef_onayi: 'bg-sky-50 text-sky-700 ring-sky-200',
  mudur_onayi: 'bg-amber-50 text-amber-800 ring-amber-200',
  onaylandi: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  reddedildi: 'bg-red-50 text-red-700 ring-red-200',
  iptal: 'bg-slate-50 text-slate-500 ring-slate-200',
};

export function DurumRozeti({ durum }: { durum: IzinDurumu }) {
  return (
    <span
      className={`whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${DURUM_BICIMI[durum]}`}
    >
      {DURUM_ETIKETI[durum]}
    </span>
  );
}

/**
 * EŞZAMANLI İZİN SINIRI ROZETİ.
 *
 * Bu alan onay zincirinin neden iki basamağa çıktığını açıklıyor;
 * gösterilmezse şef "bu neden bana geldi" diye sorar.
 */
export function SinirRozeti() {
  return (
    <span
      title="Eşzamanlı izin sınırı aşıldı — şef basamağı devreye girdi"
      className="whitespace-nowrap rounded-full bg-orange-100 px-1.5 py-0.5 text-xs font-medium text-orange-800"
    >
      Sınır
    </span>
  );
}

/**
 * SÜRE HÜCRESİ — İŞ GÜNÜ VE TAKVİM GÜNÜ BİRLİKTE.
 *
 * 4857/56 gereği iş günü sayısından hafta tatili ve resmî tatil DÜŞÜLÜR.
 * Personel "5 gün izin aldım" derken takvim gününü, sistem iş gününü sayar;
 * yalnız biri gösterilseydi itiraz konuşulamazdı.
 *
 * `isGunuSayisi` METİNDİR ve öyle basılır: `Number()`a çevrilseydi `0.50`
 * yarım gün yuvarlanır ve bakiye sessizce kayardı.
 */
export function SureHucresi({ talep }: { talep: IzinTalebiOzeti }) {
  return (
    <span className="whitespace-nowrap text-xs">
      <span className="block font-medium text-slate-900">{talep.isGunuSayisi} iş günü</span>
      <span className="block text-slate-500">{talep.takvimGunuSayisi} takvim günü</span>
      {talep.saatSayisi !== null && (
        <span className="block text-slate-500">{talep.saatSayisi} saat</span>
      )}
    </span>
  );
}

export function BakiyeListesi({ satirlar }: { satirlar: BakiyeSatiri[] }) {
  if (satirlar.length === 0) {
    return <p className="mt-1 text-sm text-slate-500">Tanımlı izin hakkı yok.</p>;
  }

  return (
    <ul className="mt-2 divide-y divide-slate-100 rounded-md border border-slate-200">
      {satirlar.map((s) => (
        <li
          key={String(s.izinTipiId)}
          className="flex items-center justify-between gap-4 px-3 py-2 text-sm"
        >
          <span className="text-slate-800">{s.izinTipiAd}</span>
          <span className="whitespace-nowrap text-xs text-slate-600">
            {/* Gün sayıları METİN olarak basılır — ondalık kaybı olmasın diye. */}
            <span className="font-medium text-slate-900">{s.toplamBakiye}</span> gün kaldı ·{' '}
            {s.toplamKullanilan}/{s.toplamHak} kullanıldı
          </span>
        </li>
      ))}
    </ul>
  );
}
